module.exports = __webpack_public_path__ + "static/media/zip-infographic.919aba7b.svg";